import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PDF_CLAIMS_UPLOAD_ENABLED_RESELLERS } from '../constants';
import { PDF_CLAIMS_ROLES } from '../constants/roles';
import { RootState } from '../redux/types';

export const usePdfClaimsFeature = (allowedRoles: string[] = PDF_CLAIMS_ROLES) => {
    const user = useSelector((state: RootState) => state.userReducer.user);
    const resellerId = useSelector((state: RootState) => state.resellerReducer.selectedReseller.value?.resellerId);

    const isPdfClaimEnabled = useMemo(
        () => {
            if (!user?.roles || !resellerId) {
                return false;
            }

            return Boolean(
                user.roles.some((role) => allowedRoles.includes(role)) &&
                    PDF_CLAIMS_UPLOAD_ENABLED_RESELLERS.includes(resellerId)
            );
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [user, resellerId]
    ); // allowed roles should be constant

    return {
        isPdfClaimEnabled,
    };
};
